import PrivateRoute from "context/PrivateRoute";
import ReactQuery from "context/ReactQuery";
import React from "react";
import { HashRouter, Route, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RecoilRoot } from "recoil";
import { icons } from "./assets/icons";
import "./scss/style.scss";
React.icons = icons;

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);
const TheLayout = React.lazy(() => import("./containers/TheLayout"));
const Login = React.lazy(() => import("./pages/auth/Login"));

const App = () => {
  return (
    <RecoilRoot>
      <HashRouter>
        <ReactQuery>
          <React.Suspense fallback={loading}>
            <Switch>
              <Route
                exact
                path="/auth/login"
                name="Login Page"
                render={(props) => <Login {...props} />}
              />
              <PrivateRoute>
                <Route
                  path="/"
                  name="Home"
                  render={(props) => <TheLayout {...props} />}
                />
              </PrivateRoute>
            </Switch>
          </React.Suspense>
        </ReactQuery>
      </HashRouter>
      <ToastContainer />
    </RecoilRoot>
  );
};

export default App;
